import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {AccountService} from '../service/account.service';

@Component({
    selector: 'app-nav-bar',
    templateUrl: './nav-bar.component.html',
    styleUrls: ['./nav-bar.component.scss'],
    standalone: false
})
export class NavBarComponent implements OnInit {
  @Input() authenticated = false;
  @Output() changeKey = new EventEmitter<void>();
  @Output() navigate = new EventEmitter<void>();

  constructor(public accountService: AccountService) { }

  ngOnInit(): void {
  }

  stripSandboxSuffix(name: string): string {
    return name.replace(/\s*\(sandbox\)\s*$/i, '');
  }
}
